import { Flag, Target, Flame, TrendingUp, Layers, Lock, Award } from "lucide-react";

const ICONS = { flag: Flag, target: Target, flame: Flame, "trending-up": TrendingUp, layers: Layers, award: Award };
const TIERS = {
  gold: "from-yellow-300 to-amber-500 shadow-[0_6px_16px_rgba(245,158,11,0.5)]",
  silver: "from-slate-200 to-slate-400 shadow-[0_6px_16px_rgba(148,163,184,0.5)]",
  bronze: "from-orange-300 to-orange-600 shadow-[0_6px_16px_rgba(234,88,12,0.4)]",
};

export default function BadgeIcon({ badge, unlocked = true, size = 64 }) {
  const Icon = ICONS[badge?.icon] || Award;
  return (
    <div className="flex flex-col items-center gap-2 text-center w-24">
      <div
        style={{ width: size, height: size }}
        className={`grid place-items-center rounded-2xl rotate-45 bg-gradient-to-br ${
          unlocked ? TIERS[badge?.tier] || TIERS.bronze : "from-su-track to-su-track shadow-none opacity-60"
        }`}
      >
        <div className="-rotate-45">
          {unlocked ? <Icon className="w-7 h-7 text-white drop-shadow" /> : <Lock className="w-6 h-6 text-su-muted" />}
        </div>
      </div>
      <div className="leading-tight">
        <div className="text-xs font-heading font-extrabold text-su-text">{badge?.name}</div>
      </div>
    </div>
  );
}
